/*
 * Mock data for the auth-free Dispensario previews (/dev/dispensario*),
 * so the full flow can be exercised without a backend/session. Passed to
 * <DispensarioPage demo={...} />. Shapes mirror the real sources:
 *   - socios: already in the page's SOCIO shape (post toSocio()).
 *   - products: like /v1/get-venue-products (category.name, price, unit_type, available).
 * The real /dispensario route ignores this and uses live data.
 */

export const DEMO_SOCIOS = [
  { id: "d1", name: "José María Fernando Caravaca de las Huertas", number: 11, credit: 40, costLine: null, photo: null },
  { id: "d2", name: "Luis Orozco", number: 12, credit: 15, costLine: null, photo: null },
  { id: "d3", name: "Ana Beltrán", number: 13, credit: 0, costLine: null, photo: null },
  { id: "d4", name: "Fernando Ruiz", number: 14, credit: 250, costLine: null, photo: null },
  { id: "d5", name: "Sofía Martínez", number: 15, credit: 30, costLine: null, photo: null },
];

export const DEMO_PRODUCTS = [
  { id: "p1", name: "Blue Dream", category: { name: "Weed" }, price: 10.0, unit_type: "weight", available: 55 },
  { id: "p2", name: "Amnesia Haze", category: { name: "Weed" }, price: 11.0, unit_type: "weight", available: 32 },
  { id: "p3", name: "Northern Lights", category: { name: "Weed" }, price: 12.0, unit_type: "weight", available: 20 },
  { id: "p4", name: "OG Kush", category: { name: "Weed" }, price: 12.5, unit_type: "weight", available: 8 },
  { id: "p5", name: "Moroccan Hash", category: { name: "Hash" }, price: 14.0, unit_type: "weight", available: 15 },
  { id: "p6", name: "Pre-roll Classic", category: { name: "Pre-rolls" }, price: 6.0, unit_type: "fixed", available: 40 },
  { id: "p7", name: "Cookies Gelato", category: { name: "Weed" }, price: 13.0, unit_type: "weight", available: 0 },
  { id: "p8", name: "Vape Cartridge OG", category: { name: "Vaporizadores" }, price: 25.0, unit_type: "fixed", available: 12 },
  { id: "p9", name: "CBD Oil 10%", category: { name: "CBD" }, price: 20.0, unit_type: "fixed", available: 18 },
];

export const DEMO_DATA = { socios: DEMO_SOCIOS, products: DEMO_PRODUCTS };
